<template>
    <div>
        <!-- <b-row> -->
            <b-modal
                :id="modal_id"
                ref="modal-xl"
                size="xl"
                :title="role.name"
                @shown="showModal"
            >
            <div>
                <b-form-group>
                    <div class="container">
                        <div class="d-flex">
                            <div class="overflow-auto p-2 mr-3">
                                <b-form-checkbox-group name="role" v-model="selectedPermissions" text-field="name">
                                    <b-form-checkbox v-for="permission in permissions" :value="permission.id" :key="permission.id">
                                        <span>{{ permission.name }}</span>
                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
            </b-modal>
        <!-- </b-row>  -->
    </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";


export default {
    name: "ModalAlerte",
    props: {
        role: Object,
        modal_id: String,
    },

    components: {
    },
    computed: {
        ...mapGetters(["permissions"]),

        hasText() {
            return this.text.length > 0 ? true : false;
        },
    },

    data() {
        return {
            selectedPermissions: []
        }
    },

    methods: {
        showModal() {
            this.selectedPermissions = this.role.permissions.map(
                (permission) => permission.id
            );
        },
    },
    created() {
    },

}

</script>